import BeltsSingle from "../components/belts/belts-single/BeltsSingle";
import Layout from "../layout/Layout";

const BeltsSinglePage = () => {
  return (
    <Layout>
      <BeltsSingle />
    </Layout>
  );
};

export default BeltsSinglePage;
